export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.detail.vue?vue&type=template&id=47274b16&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.detail.vue?vue&type=template&id=47274b16&scoped=true&
// module id = 749
// module chunks = 8